import { Input } from '@dynamika-shared/ui/Input/Input';
import { CodeEditor } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/CodeEditor';
import { useInventoryFormHandler } from '@hooks/useInventoryFormHandler';

export const Dictionary = () => {
  const { onChange, onBlur, watch, errors } = useInventoryFormHandler();

  return (
    <>
      <Input
        required
        value={watch('type')}
        name={'type'}
        onChange={e => onChange('type', e.target.value)}
        onBlur={e => onBlur('type', e.target.value)}
        data-testid={'item-type'}
        errors={errors.name?.message as string}
        label={'Type'}
        placeholder={'Type'}
        classNameInputWrapper='max-w-full'
        maxLength={255}
      />
      <CodeEditor
        classNameWrapper={'col-span-2'}
        title={'JSON'}
        language={'json'}
        value={watch('json')}
        onChange={value => onChange('json', value)}
      />
    </>
  );
};
